module.exports = __webpack_public_path__ + "img/regular_3.8452e412.jpg";